if(typeof _.min === 'undefined') { var e = new Error("Cannot find module '_.min'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = _.min;